export default __webpack_public_path__ + "static/media/Picture10.00d4569d.png";